import { iCarousel } from "./interfaces/carousel-plans";

const CarouselPlans: iCarousel[] = [
  {
    link: "",
    title: "Contrate e Concorra",
    imgDesktop: "images/plans/contrate_concorra_william_desk.png",
    imgMobile: "images/plans/contrate_concorra_william_mobile.png",
    video: "",
    cities: [
      { city: "Alfenas", uf: "MG" },
      { city: "Areado", uf: "MG" },
      { city: "Paraguaçu", uf: "MG" },
    ],
  },
  {
    link: "",
    title: "Contrate e Concorra",
    imgDesktop: "images/plans/contrate_concorra_simone_desk.png",
    imgMobile: "images/plans/contrate_concorra_simone_mobile.png",
    video: "",
    cities: [
      { city: "Belo Horizonte", uf: "MG" },
      { city: "Sete Lagoas", uf: "MG" },
      { city: "Inhaúma", uf: "MG" },
    ],
  },
  {
    link: "",
    title: "Contrate e Concorra",
    imgDesktop: "images/plans/contrate_concorra_kami_desk.png",
    imgMobile: "images/plans/contrate_concorra_kami_mobile.png",
    video: "",
    cities: [{ city: "Machado", uf: "MG" }],
  },
  {
    link: "",
    title: "Contrate e Concorra",
    imgDesktop: "images/plans/contrate_concorra_lari_desk.png",
    imgMobile: "images/plans/contrate_concorra_lari_mobile.png",
    video: "",
    cities: [{ city: "Ribeirão Preto", uf: "SP" }],
  },
  // {
  //   link: "",
  //   title: "Promoção - Black 500 MB",
  //   imgDesktop: "images/plans/500_mb_desk.png",
  //   imgMobile: "images/plans/500_mb_mobile.png",
  //   video: "",
  //   cities: [
  //     { city: "Areado", uf: "MG" },
  //     { city: "Belo Horizonte", uf: "MG" },
  //     { city: "Inhaúma", uf: "MG" },
  //     { city: "Machado", uf: "MG" },
  //     { city: "Paraguaçu", uf: "MG" },
  //     { city: "Ribeirão Preto", uf: "SP" },
  //     { city: "Sete Lagoas", uf: "MG" },
  //   ],
  // },
  // {
  //   link: "",
  //   title: "Vai perder a Black?",
  //   imgDesktop: "images/plans/black_desk.png",
  //   imgMobile: "images/plans/black_mobile.png",
  //   video: "",
  //   cities: [
  //     { city: "Areado", uf: "MG" },
  //     { city: "Belo Horizonte", uf: "MG" },
  //     { city: "Inhaúma", uf: "MG" },
  //     { city: "Machado", uf: "MG" },
  //     { city: "Paraguaçu", uf: "MG" },
  //     { city: "Ribeirão Preto", uf: "SP" },
  //     { city: "Sete Lagoas", uf: "MG" },
  //   ],
  // },
  {
    link: "",
    title: "Vem ser iTop",
    imgDesktop: "images/plans/confie_desktop.png",
    imgMobile: "images/plans/confie_mobile.png",
    video: "",
    cities: [],
  },
  // {
  //   link: "",
  //   title: "Promoção - Plano Essencial Smart 700 MB",
  //   imgDesktop: "images/plans/smart_ mulher_desk.png",
  //   imgMobile: "images/plans/smart_ mulher_mobile.png",
  //   video: "",
  //   cities: [
  //     { city: "Alfenas", uf: "MG" },
  //     { city: "Areado", uf: "MG" },
  //     { city: "Inhaúma", uf: "MG" },
  //     { city: "Machado", uf: "MG" },
  //     { city: "Paraguaçu", uf: "MG" },
  //     { city: "Sete Lagoas", uf: "MG" },
  //   ],
  // },

  // {
  //   link: "",
  //   title: "Promoção - Plano Essencial Smart 700 MB",
  //   imgDesktop: "images/plans/smart_vagalume_desk.png",
  //   imgMobile: "images/plans/smart_ smart_vagalume_mobile.png",
  //   video: "",
  //   cities: [
  //     { city: "Alfenas", uf: "MG" },
  //     { city: "Areado", uf: "MG" },
  //     { city: "Inhaúma", uf: "MG" },
  //     { city: "Machado", uf: "MG" },
  //     { city: "Paraguaçu", uf: "MG" },
  //     { city: "Sete Lagoas", uf: "MG" },
  //   ],
  // },
  // {
  //   link: "",
  //   title: "Promoção - Plano 700 MB ",
  //   imgDesktop: "images/plans/700_mb_BH_RB_desktop.png",
  //   imgMobile: "images/plans/700_mb_BH_RB_mobile.png",
  //   video: "",
  //   cities: [
  //     { city: "Ribeirão Preto", uf: "SP" },
  //     { city: "Belo Horizonte", uf: "MG" },
  //   ],
  // },
  {
    link: "https://itop.net.br/alerta-golpe",
    title: "",
    imgDesktop: "images/plans/banner_pix_desk.png",
    imgMobile: "images/plans/banner_pix_mobile.png",
    video: "",
    cities: [],
  },
];
export default CarouselPlans;
